export const ADD_PRIORITY_TO_CART = 'ADD_PRIORITY_TO_CART';

export const ADD_PRIORITY_TO_CART_SUCCESS = 'ADD_PRIORITY_TO_CART_SUCCESS';

export const ADD_PRIORITY_TO_CART_FAILED = 'ADD_PRIORITY_TO_CART_FAILED';